import { ActionLogClass, CompanyClass, ConfigClass, GradeClass, GradeClassClass, MenuClass, NewsClass, NewsTypeClass, OffSchoolClass, RegisterMealClass, ResourceClass, RoleClass, SchoolCalendarClass, SchoolClass, StudentClass, StudentDataClass, TeacherClass, UserClass, VacateClass } from "@/apis"
import { AllowLoginArgs, BindCompanyUserArgs, BindSchoolCanteenUserArgs, BindSchoolCompanyUserArgs, BindSchoolUserArgs, CreateGegistMealArgs, EditCompanyArgs, EditConfigArgs, EditGradeArgs, EditGradeClassArgs, EditMenuArgs, EditNewsArgs, EditNewsTypeArgs, EditOffSchoolArgs, EditRoleArgs, EditSchoolArgs, EditSchoolCalendarArgs, EditSelfArgs, EditStudentArgs, EditTeacherArgs, EditUserArgs, EditVacateArgs, QueryActionLogArgs, QueryCompanyArgs, QueryGetSchoolCalendarMonthlyArgs, QueryGetSchoolCalendarYearlyArgs, QueryGradeArgs, QueryGradeClassArgs, QueryMenuArgs, QueryNewsArgs, QueryNewsTypeArgs, QueryOffSchoolArgs, QueryRegisterMealArgs, QueryResourceArgs, QueryRoleArgs, QuerySchoolArgs, QueryStudentArgs, QueryTeacherArgs, QueryUserArgs, QueryVacateArgs, SetMenuArgs, StudentDineStatArgs, UploadResourceArgs, VacateStatArgs } from "@/models/args"
import { ActionLogDto, CompanyDto, ConfigDto, GradeClassDto, GradeDto, ImportStudentDto, ImportStudentResultDto, MenuDto, NewsDto, NewsTypeDto, OffSchoolDto, RegisterMealDto, ResourceDto, RoleDto, SchoolCalendarDto, SchoolCalendarMonthDto, SchoolDto, StatCountDto, StatLineDto, StudentDto, TeacherDto, UserDto, VacateDto, VacateStatDto } from "@/models/dtos"
import { OptionsType } from "@/models/types"
import { defineStore } from "pinia"

const actionLogApi = new ActionLogClass()
const companyApi = new CompanyClass()
const configApi = new ConfigClass()
const gradeClassApi = new GradeClassClass()
const gradeApi = new GradeClass()
const menuApi = new MenuClass()
const newsApi = new NewsClass()
const newsTypeApi = new NewsTypeClass()
const offSchoolApi = new OffSchoolClass()
const registerMealApi = new RegisterMealClass()
const resourceApi = new ResourceClass()
const roleApi = new RoleClass()
const schoolApi = new SchoolClass()
const schoolCalendarApi = new SchoolCalendarClass()
const studentApi = new StudentClass()
const teacherApi = new TeacherClass()
const userApi = new UserClass()
const vacateApi = new VacateClass()
const studentDataApi = new StudentDataClass()
export const useDataStore = defineStore('data',{
  state: () => {
    return {
      isVacate: false,
      
      actionLogTotal: 0,
      companyTotal: 0,
      gradeClassTotal: 0,
      gradeTotal: 0,
      menuTotal: 0,
      newsTotal: 0,
      newsTypeTotal: 0,
      offSchoolTotal: 0,
      registerMealTotal: 0,
      resourceTotal: 0,
      roleTotal: 0,
      schoolTotal: 0,
      studentTotal: 0,
      teacherTotal: 0,
      userTotal: 0,
      vacateTotal: 0,

      roleOptions: <OptionsType[]>[],
      newsTypeOptions: <OptionsType[]>[],
      gradeClassOptions: <OptionsType[]>[],
      gradeOptions: <OptionsType[]>[],
      schoolOptions: <OptionsType[]>[],
      sexOptions: [{label: '男', value: 1},{label: '女', value: 2}],
      isOptions: [{label: '是', value: 1},{label: '否', value: 0}],
      isBoolOptions: [{label: '是', value: true},{label: '否', value: false}],
      isVacateOptions: [{label: '正常', value: true},{label: '销假', value: false}],
      regTypeOptions: [{label: '自动报名', value: 0},{label: '手动报名', value: 1}],
      mealTypeOptions: [{label: '早餐', value: 1},{label: '午餐', value: 2},{label: '晚餐', value: 3}],
      studentStateOptions: [{label: '正常', value: 0},{label: '请假', value: 1},{label: '离校', value: 2},{label: '未报名', value: 3}],
      configTypeOptions: [{label: '文本', value: 1},{label: '数值', value: 2},{label: '文本域', value: 3},{label: '开关', value: 4},{label: '上传', value: 5}],
    }
  },
  getters: {},
  actions: {
    setIsVacate(value: boolean){
      this.$patch({
        isVacate: value
      })
    },
    //#region 操作日志
    getActionLogList(args: QueryActionLogArgs){
      return new Promise<ActionLogDto[]>((resolve, reject) => {
        actionLogApi.gets(args).then((resp) => {

          this.$patch({
            actionLogTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 公司
    getCompanyList(args: QueryCompanyArgs){
      return new Promise<CompanyDto[]>((resolve, reject) => {
        companyApi.gets(args).then((resp) => {

          this.$patch({
            companyTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createCompany(args: EditCompanyArgs){
      return new Promise<number>((resolve, reject) => {
        companyApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editCompany(args: EditCompanyArgs){
      return new Promise<number>((resolve, reject) => {
        companyApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeCompany(id: number){
      return new Promise<number>((resolve, reject) => {
        companyApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    detailCompany(id: number){
      return new Promise<CompanyDto>((resolve, reject) => {
        companyApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    bindCompany(args: BindCompanyUserArgs){
      return new Promise<number>((resolve, reject) => {
        companyApi.bind(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    unbindCompany(id: number){
      return new Promise<number>((resolve, reject) => {
        companyApi.unbind(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 系统配置
    getConfigList(){
      return new Promise<ConfigDto[]>((resolve, reject) => {
        configApi.gets().then((resp) => {
          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createConfig(args: EditConfigArgs){
      return new Promise<number>((resolve, reject) => {
        configApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editConfig(args: EditConfigArgs[]){
      return new Promise<number>((resolve, reject) => {
        configApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 班级
    getGradeClassList(args: QueryGradeClassArgs){
      return new Promise<GradeClassDto[]>((resolve, reject) => {
        gradeClassApi.gets(args).then((resp) => {

          this.$patch({
            gradeClassTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createGradeClass(args: EditGradeClassArgs){
      return new Promise<number>((resolve, reject) => {
        gradeClassApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editGradeClass(args: EditGradeClassArgs){
      return new Promise<number>((resolve, reject) => {
        gradeClassApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeGradeClass(id: number){
      return new Promise<number>((resolve, reject) => {
        gradeClassApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    detailGradeClass(id: number){
      return new Promise<GradeClassDto>((resolve, reject) => {
        gradeClassApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    unbindGradeClassTeacher(id: number){
      return new Promise<number>((resolve, reject) => {
        gradeClassApi.unbind(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    bindGradeClassTeacher(id: number, teacherId: number){
      return new Promise<number>((resolve, reject) => {
        gradeClassApi.bind(id, teacherId).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 年级
    getGradeList(args: QueryGradeArgs){
      return new Promise<GradeDto[]>((resolve, reject) => {
        gradeApi.gets(args).then((resp) => {

          this.$patch({
            gradeTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createGrade(args: EditGradeArgs){
      return new Promise<number>((resolve, reject) => {
        gradeApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editGrade(args: EditGradeArgs){
      return new Promise<number>((resolve, reject) => {
        gradeApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeGrade(id: number){
      return new Promise<number>((resolve, reject) => {
        gradeApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    detailGrade(id: number){
      return new Promise<GradeDto>((resolve, reject) => {
        gradeApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 权限菜单
    getMenuList(args: QueryMenuArgs){
      return new Promise<MenuDto[]>((resolve, reject) => {
        menuApi.gets(args).then((resp) => {

          this.$patch({
            menuTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createMenu(args: EditMenuArgs){
      return new Promise<number>((resolve, reject) => {
        menuApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editMenu(args: EditMenuArgs){
      return new Promise<number>((resolve, reject) => {
        menuApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    sortMenu(id: number, sort: number){
      return new Promise<number>((resolve, reject) => {
        menuApi.sort(id, sort).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    menusMenu(){
      return new Promise<MenuDto[]>((resolve, reject) => {
        menuApi.menus().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
    //#region 新闻
    getNewsList(args: QueryNewsArgs){
      return new Promise<NewsDto[]>((resolve, reject) => {
        newsApi.gets(args).then((resp) => {

          this.$patch({
            newsTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createNews(args: EditNewsArgs){
      return new Promise<number>((resolve, reject) => {
        newsApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editNews(args: EditNewsArgs){
      return new Promise<number>((resolve, reject) => {
        newsApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeNews(id: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    detailNews(id: number){
      return new Promise<NewsDto>((resolve, reject) => {
        newsApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    publishNews(id: number, status: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.publish(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    topNews(id: number, status: number){
      return new Promise<number>((resolve, reject) => {
        newsApi.top(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    homeNews(id: number, status: boolean){
      return new Promise<number>((resolve, reject) => {
        newsApi.home(id, status).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 新闻分类
    getNewsTypeList(args: QueryNewsTypeArgs){
      return new Promise<NewsTypeDto[]>((resolve, reject) => {
        newsTypeApi.gets(args).then((resp) => {

          this.$patch({
            newsTypeTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createNewsType(args: EditNewsTypeArgs){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editNewsType(args: EditNewsTypeArgs){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeNewsType(id: number){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    detailNewsType(id: number){
      return new Promise<NewsTypeDto>((resolve, reject) => {
        newsTypeApi.detail(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    sortNewsType(id: number, sort: number){
      return new Promise<number>((resolve, reject) => {
        newsTypeApi.sort(id, sort).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 离校
    getOffSchoolList(args: QueryOffSchoolArgs){
      return new Promise<OffSchoolDto[]>((resolve, reject) => {
        offSchoolApi.gets(args).then((resp) => {

          this.$patch({
            offSchoolTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createOffSchool(args: EditOffSchoolArgs){
      return new Promise<number>((resolve, reject) => {
        offSchoolApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeOffSchool(id: number){
      return new Promise<number>((resolve, reject) => {
        offSchoolApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportsOffSchool(args: QueryOffSchoolArgs){
      return new Promise<File>((resolve, reject) => {
        offSchoolApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
    
    //#region 就餐报名
    getRegisterMealList(args: QueryRegisterMealArgs){
      return new Promise<RegisterMealDto[]>((resolve, reject) => {
        registerMealApi.gets(args).then((resp) => {

          this.$patch({
            registerMealTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeRegisterMeal(id: number){
      return new Promise<number>((resolve, reject) => {
        registerMealApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createRegisterMeal(args: CreateGegistMealArgs){
      return new Promise<number>((resolve, reject) => {
        registerMealApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportsRegisterMeal(args: QueryRegisterMealArgs){
      return new Promise<File>((resolve, reject) => {
        registerMealApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    autoReg(gradeId: number, mealMonth: string){
      return new Promise<number>((resolve, reject) => {
        registerMealApi.autoReg(gradeId,mealMonth).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 资源
    getResourceList(args: QueryResourceArgs){
      return new Promise<ResourceDto[]>((resolve, reject) => {
        resourceApi.gets(args).then((resp) => {

          this.$patch({
            resourceTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createResource(args: FormData){
      return new Promise<ResourceDto>((resolve, reject) => {
        resourceApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
    //#region 角色
    getRoleList(args: QueryRoleArgs){
      return new Promise<RoleDto[]>((resolve, reject) => {
        roleApi.gets(args).then((resp) => {

          this.$patch({
            roleTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    getAllRoleList(){
      return new Promise<RoleDto[]>((resolve, reject) => {
        roleApi.all().then((resp) => {

          const roleOptions = resp.map(x => {
            return {
              label: x.name,
              value: x.id
            }
          })
          
          this.$patch({
            roleOptions
          })
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createRole(args: EditRoleArgs){
      return new Promise<number>((resolve, reject) => {
        roleApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editRole(args: EditRoleArgs){
      return new Promise<number>((resolve, reject) => {
       roleApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeRole(id: number){
      return new Promise<number>((resolve, reject) => {
        roleApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    setMenusRole(id: number, args: SetMenuArgs){
      return new Promise<number>((resolve, reject) => {
        roleApi.setMenus(id, args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
    //#region 学校日历
    getMonthSchoolCalendarList(args: QueryGetSchoolCalendarMonthlyArgs){
      return new Promise<SchoolCalendarDto[]>((resolve, reject) => {
        schoolCalendarApi.getMonth(args).then((resp) => {          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    getYearSchoolCalendarList(args: QueryGetSchoolCalendarYearlyArgs){
      return new Promise<SchoolCalendarMonthDto[]>((resolve, reject) => {
        schoolCalendarApi.getYear(args).then((resp) => {          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createSchoolCalendar(args: EditSchoolCalendarArgs[]){
      return new Promise<number>((resolve, reject) => {
        schoolCalendarApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    getStudentMounthState(studentId: number){
      return new Promise<number>((resolve, reject) => {
        schoolCalendarApi.getStudentMounthState(studentId).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
    //#region 学校
    getSchoolList(args: QuerySchoolArgs){
      return new Promise<SchoolDto[]>((resolve, reject) => {
        schoolApi.gets(args).then((resp) => {

          this.$patch({
            schoolTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createSchool(args: EditSchoolArgs){
      return new Promise<number>((resolve, reject) => {
        schoolApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editSchool(args: EditSchoolArgs){
      return new Promise<number>((resolve, reject) => {
        schoolApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeSchool(id: number){
      return new Promise<number>((resolve, reject) => {
        schoolApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    bindUserSchool(args: BindSchoolUserArgs){
      return new Promise<number>((resolve, reject) => {
        schoolApi.bindUser(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    bindCanteenSchool(args: BindSchoolCanteenUserArgs){
      return new Promise<number>((resolve, reject) => {
        schoolApi.bindCanteen(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    bindCompanySchool(args: BindSchoolCompanyUserArgs){
      return new Promise<number>((resolve, reject) => {
        schoolApi.bindCompany(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 学生
    getStudentList(args: QueryStudentArgs){
      return new Promise<StudentDto[]>((resolve, reject) => {
        studentApi.gets(args).then((resp) => {

          this.$patch({
            studentTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createStudent(args: EditStudentArgs){
      return new Promise<number>((resolve, reject) => {
        studentApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editStudent(args: EditStudentArgs){
      return new Promise<number>((resolve, reject) => {
        studentApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeStudent(id: number){
      return new Promise<number>((resolve, reject) => {
        studentApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportsStudent(args: QueryStudentArgs){
      return new Promise<File>((resolve, reject) => {
        studentApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    downloadStudent(){
      return new Promise<File>((resolve, reject) => {
        studentApi.download().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 老师
    getTeacherList(args: QueryTeacherArgs){
      return new Promise<TeacherDto[]>((resolve, reject) => {
        teacherApi.gets(args).then((resp) => {

          this.$patch({
            teacherTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportsTeacher(args: QueryTeacherArgs){
      return new Promise<File>((resolve, reject) => {
        teacherApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createTeacher(args: EditTeacherArgs){
      return new Promise<number>((resolve, reject) => {
        teacherApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editTeacher(args: EditTeacherArgs){
      return new Promise<number>((resolve, reject) => {
        teacherApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    unbindTeacher(id: number){
      return new Promise<number>((resolve, reject) => {
        teacherApi.unbind(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeTeacher(id: number){
      return new Promise<number>((resolve, reject) => {
        teacherApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 用户
    getUserList(args: QueryUserArgs){
      return new Promise<UserDto[]>((resolve, reject) => {
        userApi.gets(args).then((resp) => {

          this.$patch({
            userTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createUser(args: EditUserArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editUser(args: EditUserArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.edit(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    editSelfUser(args: EditSelfArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.self(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    removeUser(id: string){
      return new Promise<number>((resolve, reject) => {
        userApi.remove(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    allowUser(args: AllowLoginArgs){
      return new Promise<number>((resolve, reject) => {
        userApi.allow(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion

    //#region 请假
    getVacateList(args: QueryVacateArgs){
      return new Promise<VacateDto[]>((resolve, reject) => {
        vacateApi.gets(args).then((resp) => {

          this.$patch({
            vacateTotal: resp.total
          })
          
          resolve(resp.data)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportsVacate(args: QueryVacateArgs){
      return new Promise<File>((resolve, reject) => {
        vacateApi.exports(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    createVacate(args: EditVacateArgs){
      return new Promise<number>((resolve, reject) => {
        vacateApi.create(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    destroyVacate(id: number){
      return new Promise<number>((resolve, reject) => {
        vacateApi.destroy(id).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    dashboardStat(){
      return new Promise<StatCountDto>((resolve, reject) => {
        vacateApi.stat().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    dashboardLine(){
      return new Promise<StatLineDto[]>((resolve, reject) => {
        vacateApi.line().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    vacateStat(args: VacateStatArgs){
      return new Promise<VacateStatDto[]>((resolve, reject) => {
        vacateApi.vacateStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportVacateStat(args: VacateStatArgs){
      return new Promise<File>((resolve, reject) => {
        vacateApi.exportVacateStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    studentDineDetailStat(args: StudentDineStatArgs){
      return new Promise<string>((resolve, reject) => {
        vacateApi.studentDineDetailStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportStudentDineDetailStat(args: StudentDineStatArgs){
      return new Promise<File>((resolve, reject) => {
        vacateApi.exportStudentDineDetailStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    gradeClassDineStat(args: StudentDineStatArgs){
      return new Promise<string>((resolve, reject) => {
        vacateApi.gradeClassDineStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    exportGradeClassDineStat(args: StudentDineStatArgs){
      return new Promise<File>((resolve, reject) => {
        vacateApi.exportGradeClassDineStat(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
    //#region 学生导入
    importFile(formdata: FormData){
      return new Promise<ImportStudentResultDto>((resolve, reject) => {
        studentDataApi.importFile(formdata).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
  
    confirmImport(args: ImportStudentDto[]){
      return new Promise<number>((resolve, reject) => {
        studentDataApi.confirmImport(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getInfo(schoolId: number){
      return new Promise<string>((resolve, reject) => {
        studentDataApi.getInfo(schoolId).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    clearInfo(schoolId: number){
      return new Promise<number>((resolve, reject) => {
        studentDataApi.clearInfo(schoolId).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },
    //#endregion
  
  }
})